import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@quintoandar/cozy-core/Box';
import AddAPhoto from '@quintoandar/cozy-icons/AddAPhoto';
import Button from '@quintoandar/cozy-core/Button';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import {
  changeDropZoneVisibilityAction,
} from 'containers/PhotosManager/action';
import { makeSelectPhotoListDropzoneVisibility } from 'containers/PhotosManager/selectors';
import messages from './messages';

export const UploadButton = ({ changeDropZoneVisibility }) => {
  const onButtonClick = () => {
    changeDropZoneVisibility(true);
  };

  return (
    <Box my={1}>
      <Button variant="quiet" icon={AddAPhoto} onClick={onButtonClick}>
        <FormattedMessage {...messages.addPhotosphereLabel} />
      </Button>
    </Box>
  );
};

export const mapDispatchToProps = (dispatch) => ({
  changeDropZoneVisibility: (visibility) => dispatch(changeDropZoneVisibilityAction(visibility)),
});

const mapStateToProps = createStructuredSelector({
  dropzoneVisibility: makeSelectPhotoListDropzoneVisibility(),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

UploadButton.propTypes = {
  changeDropZoneVisibility: PropTypes.func.isRequired,
};

export default compose(
  withConnect,
)(UploadButton);
